<template>
  <!-- 课程13 -->
  <div class="lessonTen">
    <div class="web_content">
      <div class="title">第5章 神经网络（13 神经网络基础 ）</div>
      <div class="content">
        传统上，自然语言和图像处理等领域一直是AI的痛点；现在，随着神经网络和深度学习的研究进展，AI在这些领域取得了重大进步。
        在第 5 章中，我们将介绍以下部分。
      </div>
      <div class="content">
        一、
        <span @click="jumpOne" style="color:#0090ff;cursor: pointer;" class="index">神经网络基础 （0/1）</span>
      </div>
      <div class="content">
        二、
        <span @click="jumpTow" style="color:#0090ff;cursor: pointer;" class="index">如何建立神经网络 （0/2）</span>
      </div>
      <div class="content">
        三、
        <span @click="jumpThree" style="color:#0090ff;cursor: pointer;" class="index">先进的神经网络技术 （---）</span>
      </div>

      <div class="title-child" id="productId">第1节 神经网络基础</div>

      <div class="content">
        我们的下一个主题，即深度学习和神经网络，这往往比其他许多主题能吸引更多的兴趣。
        <br />引起兴趣的原因之一是希望了解我们自己的大脑，这是从我们大脑的神经处理中产生的；另一个原因是近年来，通过结合海量数据集和深度学习技术，机器学习取得了很大的进展。
      </div>

      <div class="title-child-bold">一、什么是神经网络？</div>
      <div class="content">
        为了更好地理解整体的情况，我们将从讨论组成它的各个单元开始。神经网络可以表示为“真实的”生物神经网络（例如大脑中的神经网络），也可以表示为在计算机中模拟的人工神经网络。
      </div>

      <div class="title-child-bold">1. 深度学习</div>
      <div class="content">
        深度学习是指某种类型的机器学习技术，在这种技术中，几个简单的处理单元“层”连接在一个网络中，这样，系统的输入就依次通过每一个单元。这种结构的灵感来自于大脑中视觉信息的处理，这些信息通过眼睛进入并被视网膜捕获。这种深度允许网络学习更复杂的结构，而不需要大量的数据。
      </div>

      <div class="title-child-bold">2. 神经元，细胞体和信号</div>

      <div class="content">
        一个神经网络，无论是生物的还是人工的，都由大量简单的单元即神经元组成，它们相互之间接收和传输信号。神经元是非常简单的信息处理器，由细胞体和连接导线组成。在大多数情况下，他们什么都不做，只是静静地呆着，看着信号从导线里传进来。
      </div>

      <div class="title-child-bold">3. 树突，轴突和突触</div>

      <div class="content">
        在生物学术语中，我们称这些提供输入的导线为神经元树突。有时，根据传入的信号，神经元可能会触发并发出一个信号，以供其他神经元接收。传输输出信号的导线称为轴突。每个轴突在交叉点处可能连接到一个或多个树突，这个交叉点称为突触。
        <br />与其它神经元相隔离，单个神经元并不令人印象深刻，并且只能执行一组非常有限的行为。但是，当它们彼此连接时，它们协调作用形成的系统就可能变得极其复杂。要寻找这方面的证据，只需查看（使用法律用语）“附件A”：您的大脑！系统的行为取决于神经元连接在一起的方式。每个神经元对传入的信号都会做出特定的反应，这种反应也可以随着时间的推移而适应。众所周知，这种适应是诸如记忆和学习之类的功能的关键。
      </div>
      <div class="title-child-bold">【知识巩固】</div>
      <div class="title-child-bold">练习20.神经网络的要素</div>
      <div class="content">
        在下图中标记神经元的不同组成部分。提示：神经元的输入来自左侧，而输出则位于右侧。
      </div>
      <img src="../assets/13-01.png" />

      <div class="text">
        突触（连接）<input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="统计"
          :disabled="isDisabledOne"
        /><label>A</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器人"
          :disabled="isDisabledOne"
        /><label>B</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>C</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>D</label>
      </div>
      <div class="text fontBig">
        树突（输入）<input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="统计"
          :disabled="isDisabledOne"
        /><label>A</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器人"
          :disabled="isDisabledOne"
        /><label>B</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>C</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>D</label>
      </div>

      <div class="content">
        细 胞 体      <input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="统计"
          :disabled="isDisabledOne"
        /><label>A</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器人"
          :disabled="isDisabledOne"
        /><label>B</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>C</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>D</label>
      </div>

      <div class="text fontBig">
        轴突（输出）<input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="统计"
          :disabled="isDisabledOne"
        /><label>A</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器人"
          :disabled="isDisabledOne"
        /><label>B</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>C</label
        ><input
          style="marginleft: 15px"
          type="radio"
          v-model="chooseeight"
          value="机器学习"
          :disabled="isDisabledOne"
        /><label>D</label>
      </div>

      <button class="sentBtn" style="marginleft: 290px" @click="sentBtnOne">
        提交
      </button>

      <div class="title-child-bold">二、为什么要发展人工神经网络？</div>
      <div class="content">
        建立大脑人工模型，通常是神经科学、大脑和神经系统的研究领域。人们很容易想到，通过对人的大脑进行足够详细的了解，就可以发现人与动物在认知和意识方面的秘密。
      </div>

      <img src="../assets/13-02.png" />

      <div class="title-child-bold">1. 模拟大脑</div>

      <div class="content">
        由美国神经科学研究人员领导的“大脑倡议”正在推进成像、建模和模拟大脑的技术，其规模比以前更精细、更大。就目标而言，一些大脑研究项目也非常雄心勃勃。大约在5年前，人类大脑计划就承诺“可以很快解决大脑的奥秘”。经过多年的工作，人类大脑项目面临着一个问题，即欧盟投资的10亿欧元何时才能兑现承诺，不过，公平地说，一些不那么雄心勃勃的重要项目倒是已经实现。
        <br />然而，尽管我们似乎离理解思维和意识还差得很远，但在神经科学领域却已经取得了明显的里程碑式的成就。通过更好地了解大脑的结构和功能，我们已经获得了一些具体的回报。例如，我们可以识别异常功能，并尝试帮助大脑避免这些异常以恢复正常操作。这可以为患有神经系统疾病的人带来改变生活的新疗法，这些疾病包括：癫痫、阿尔茨海默、发育障碍引起的问题或受伤造成的损害等。
      </div>
      <div class="title-child-bold">2. 展望未来：脑机接口</div>

      <div class="content">
        神经科学的一个研究方向是脑机接口，它允许通过简单的思考与计算机进行交互。当前的接口非常有限，例如，它们可以用于在非常粗糙的水平上重建一个人所看到的内容，或者通过思想来控制机械臂或无人机。也许有一天我们真的可以使用一种思想阅读机，该机器可以提供精确的指令，但目前它们属于科幻小说。也可以想象，我们通过小的电子脉冲刺激大脑，从而将信息输入大脑。这种刺激目前用于治疗目的。提供详细的信息，例如特定的文字、想法、记忆或情感，至少在目前是科幻小说，而不是现实，但显然，我们既不知道这种技术的局限性，也不知道要达到这些技术有多么困难。
        <br />噢，我们对课程的主题有些偏离。实际上，建立人工神经网络的另一个主要原因与了解生物系统几乎无关。我们只是以生物系统为灵感来构建更好的AI和机器学习技术。这个想法很自然：大脑是一个非常复杂的信息处理系统，能够进行各种各样的智能行为（偶尔还有一些不太智能的行为），因此，当我们尝试创建人工智能系统时，在其中寻找灵感是有意义的。
        <br />自1960年代以来，神经网络一直是AI的主要发展趋势。在最后一部分，我们将回到人工智能历史上的流行浪潮。目前，神经网络又一次位居榜首，因为深度学习被用来在许多领域取得显著进步，如自然语言和图像处理，而这些领域曾经是AI的痛点。
      </div>
      <div class="title-child-bold">三、神经网络有什么特别之处？</div>
      <div class="content">
        通常，将神经网络作为AI的一种方法，其理由与基于逻辑的方法类似。在后一种情况下，人们认为，为了达到人类的智能水平，我们需要模拟更高层次的思维过程，尤其是使用逻辑规则来操纵代表某些具体或抽象概念的符号。
        <br />神经网络的论点是，通过在神经元和神经网络的层次上模拟较低层次的“亚符号”数据处理，将会出现智能。这一切听起来都很合理，但要记住，为了制造飞行机器，我们不制造能拍动翅膀的飞机，也不制造由骨头、肌肉和羽毛组成的飞机。同样，在人工神经网络中，通常会忽略神经元的内部机制，并且人工神经元通常比自然神经元简单得多。当目标是建立AI系统而不是模拟生物系统时，在人工模型中，自然神经元之间的电化学信号机制也通常会被忽略。
        <br />与传统的计算机工作方式相比，神经网络有一些特殊的特点：
      </div>

      <div class="title-child-bold">1. 神经网络关键特征1</div>
      <div class="content">
        首先，在传统计算机中，信息是在中央处理器（简称CPU）中处理的，中央处理器一次只能专注于一件事情。CPU可以从计算机的内存中检索要处理的数据，并将结果存储在内存中。因此，数据的存储和处理由计算机的两个独立组件处理：内存和CPU。在神经网络中，系统由大量神经元组成，每个神经元都可以自己处理信息，这样，神经元就可以同时处理大量信息，而不是让CPU一个接一个地处理每条信息。
      </div>
      <div class="title-child-bold">2. 神经网络关键特征2</div>

      <div class="content">
        第二个区别是数据存储（内存）和处理不像传统计算机那样分开。神经元同时存储和处理信息，因此无需从内存中检索数据进行处理。数据可以短期存储在神经元本身中（它们在任何给定时间发射或不发射），也可以长期存储在神经元之间的连接中，即所谓的权重，我们将在下面讨论。
        <br />由于这两个差异，神经网络和传统计算机适用于、不同的任务。尽管完全有可能在传统计算机中模拟神经网络（这是它们被长期使用的方式），但只有当我们使用能够同时处理许多信息的特殊硬件（计算机设备）时，才能实现神经网络的最大容量，这称为并行处理。顺便说一句，图形处理器（或图形处理单元，GPU）具有这种能力，它们已成为运行大规模深度学习方法的一种经济高效的解决方案。
      </div>
    </div>
     <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDisabledOne:false,
    };
  },
  created() {},
  computed: {},
  components: {},
  mounted() {},
  methods: {   
    sentBtnOne() {
      this.isDisabledOne = true;
    },
    
    jumpOne(){
      const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    jumpTow(){
      this.$router.push('/lessonFourteen');
    },
   
    jumpThree(){
       this.$router.push('/lessonFifteen');
       
    },
    goBlank(){
      this.$router.push('/lessonTwelve');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/lessonFourteen');
    },
    
    },
};
</script>

<style scoped>
.lessonTen {
  width: 100%;
}
.web_content {
  width: 650px;
  margin: 0 auto;
  padding: 0px 75px;
  background: #fff;
}
.title {
  font-size: 22px;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
}
.content {
  text-indent: 2em;
  font-size: 16px;
  line-height: 35px;
}
.index {
  font-size: 16px;
  color: #0090ff;
  line-height: 15px;
}
.title-child {
  font-size: 22px;
  color: #000;
  margin-top: 30px;
}
.title-child-bold {
  font-size: 16px;
  color: #000;
  margin-top: 30px;

  font-weight: bold;
}

.content-red {
  color: #f15a23;
  font-size: 16px;
  line-height: 35px;
  text-indent: 2em;
}
.content-imgtext {
  margin-left: 40%;
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.backBtn button{
  width: 100px;
}
</style>

















// WEBPACK FOOTER //
// src/components/lessonThirteen.vue